<script setup>
// Config do nó Template WhatsApp — modelo aprovado pela Meta + variáveis + URL de header (mídia).
// Espelha SendWATemplateConfig; carrega templates das inboxes WhatsApp da conta quando disponíveis.
import { computed, ref, inject, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
/* global axios */
import FlowField from './FlowField.vue';

const props = defineProps({ node: { type: Object, required: true } });
const { t } = useI18n();
const aux = inject('flowAux', {});
const d = computed(() => props.node.data);

const templates = ref([]);
const loading = ref(false);

const load = async () => {
  loading.value = true;
  try {
    const inboxes =
      (await axios.get(`/api/v1/accounts/${aux.accountId}/inboxes`)).data
        .payload || [];
    const wa = inboxes.filter(i => (i.channel_type || '').includes('Whatsapp'));
    wa.forEach(i => {
      (i.message_templates || []).forEach(tpl => templates.value.push(tpl));
    });
  } catch (e) {
    /* sem inbox WA */
  } finally {
    loading.value = false;
  }
};

const options = computed(() => [
  {
    value: '',
    label: templates.value.length
      ? t('CHATBOT.nodeConfig.sendWATemplate.selectPlaceholder')
      : t('CHATBOT.nodeConfig.sendWATemplate.noTemplates'),
  },
  ...templates.value.map(tpl => ({
    value: tpl.name,
    label: `${tpl.name} (${tpl.language})${tpl.status === 'approved' ? ' ✓' : ''}`,
  })),
]);

const variablesText = computed({
  get: () => (d.value.variables || []).join('|'),
  set: v => {
    d.value.variables = v.split('|').map(s => s.trim());
  },
});

onMounted(load);
</script>

<template>
  <div>
    <div
      class="p-2 mb-3 text-[0.6875rem] rounded bg-n-alpha-1 border border-n-weak text-n-slate-11"
    >
      {{ t('CHATBOT.nodeConfig.sendWATemplate.infoText') }}
    </div>

    <FlowField
      v-if="templates.length"
      :model-value="d.templateName"
      :label="t('CHATBOT.nodeConfig.sendWATemplate.templateLabel')"
      type="select"
      :options="options"
      @update:model-value="d.templateName = $event"
    />
    <FlowField
      :model-value="d.templateName"
      :label="
        templates.length
          ? t('CHATBOT.nodeConfig.sendWATemplate.orTypeName')
          : t('CHATBOT.nodeConfig.sendWATemplate.templateNameLabel')
      "
      type="text"
      placeholder="ex: boas_vindas"
      @update:model-value="d.templateName = $event"
    />

    <FlowField
      :model-value="variablesText"
      :label="t('CHATBOT.nodeConfig.sendWATemplate.variablesPipeLabel')"
      type="text"
      placeholder="João|Pedido 123"
      :hint="t('CHATBOT.nodeConfig.sendWATemplate.variablesPipeHint')"
      @update:model-value="variablesText = $event"
    />
    <FlowField
      :model-value="d.headerUrl"
      :label="t('CHATBOT.nodeConfig.sendWATemplate.headerUrlLabel')"
      type="text"
      placeholder="https://exemplo.com/imagem.jpg"
      @update:model-value="d.headerUrl = $event"
    />
    <p v-if="loading" class="text-xs text-n-slate-10 mt-1">
      {{ t('CHATBOT.nodeConfig.sendWATemplate.loading') }}
    </p>
    <p class="text-xs text-n-slate-10 mt-1">
      {{ t('CHATBOT.nodeConfig.sendWATemplate.officialOnly') }}
    </p>
  </div>
</template>
